export default __webpack_public_path__ + "static/media/0700ROUGE.075f3321.pdf";